import React from "react";
import { useState } from "react";
import Image from "@/components/Atoms/Image";
import CustomLink from "@/components/Atoms/CustomLink";
import DesignToken from "@/components/DesignTokens/index";
import { DesktopNavigationMenu } from "@/components/Molecules/NavigationMenu";
import { MobileNavigationMenu } from "@/components/Molecules/NavigationMenu";
import { BurgerMenuButton } from "@/components/Atoms/Buttons";
import { List } from "@/atoms/List";
import { LangSelector } from "@/molecules/LangSelector";
import { SocialLink } from "@/molecules/SocialLink";
import styles from "./index.module.scss";

interface Props {
  data: any;
  locales: string;
  currentLocale: string;
  social: any;
}

export function MenuBar({ data, locales, currentLocale, social }: Props) {
  const localesToShow = process.env.NEXT_PUBLIC_LOCALES_TO_SHOW ?? "";
  const languageList = localesToShow.split(",");
  const [activeMenu, setActiveMenu] = useState(false);

  const toggleMenu = () => {
    setActiveMenu(!activeMenu);
  };

  const cut = Math.ceil(data.items.length / 2);
  const first = data.items.slice(0, cut);
  const last = data.items.slice(cut, data.items.length);

  if (data.toggleAltLogoForMobile) {
    var logo = data.logo;
  } else {
    var logo = data.logoColour;
  }

  return (
    <DesignToken
      layout="menuBar"
      type={data.headerMenuBarStyle}
      color={data.desktopMenuBackgroudColor?.color}
    >
      {data.logoAlignment === "center" ? (
        <>
          {data.navigationLinksAlignment === "left" ? (
            <>
              <nav className="z-[1] flex-row justify-between px-6  lg:container mx-auto fixed  left-0 right-0 lg:static flex h-[90px]">
                <div className="hidden lg:flex lg:min-w-[20rem] justify-start">
                  <DesktopNavigationMenu
                    bg={data.desktopMenuBackgroudColor?.color}
                    color={data.desktopMenuItemsTextColor?.color}
                    togglers={data.menuTogglersColor?.color}
                    locales={locales}
                    currentLocale={currentLocale}
                    items={data.items}
                  />
                </div>

                <div className="flex flex-row items-center py-4">
                  <CustomLink href="/">
                    {data.toggleAltLogoForMobile ? (
                      <>
                        <Image
                          className={` ${styles.imgSize}  hidden lg:inline  `}
                          data={data.logo}
                        />
                        <Image
                          className={`${styles.imgSize}   lg:hidden `}
                          data={logo}
                        />
                      </>
                    ) : (
                      <>
                        <Image
                          className={`${styles.imgSize} `}
                          data={data.logo}
                        />
                      </>
                    )}
                  </CustomLink>
                </div>

                <div className="hidden lg:flex  gap-6 justify-end lg:min-w-[20rem]">
                  <List tag="ordered" style="listBar">
                    <LangSelector
                      color={data.menuTogglersColor?.color}
                      locales={locales}
                      currentLocale={currentLocale}
                    />
                  </List>
                  {data.addSocialLinks && (
                    <SocialLink
                      data={social.socialLinks}
                      color={data.menuTogglersColor?.color}
                    />
                  )}
                </div>
                <div className="flex lg:hidden items-center">
                  <BurgerMenuButton
                    close={data.closeMenuIcon?.img}
                    burger={data.burgerMenuIcon?.img}
                    color={data.menuTogglersColor?.color}
                    toggleMenu={activeMenu}
                    onClick={() => toggleMenu()}
                  />
                </div>
              </nav>
            </>
          ) : (
            <nav className="z-[1] flex-row justify-between px-6 lg:container mx-auto fixed  left-0 right-0 lg:static flex h-[90px]">
              {languageList.length > 1 && (
                <div className="hidden lg:flex min-w-[6rem]">
                  <List tag="ordered" style="listBar">
                    <LangSelector
                      color={data.menuTogglersColor?.color}
                      locales={locales}
                      currentLocale={currentLocale}
                    />
                  </List>
                </div>
              )}

              <div className="grouperNav flex gap-16">
                <div className="hidden lg:flex xl:min-w-[20rem]">
                  <DesktopNavigationMenu
                    bg={data.desktopMenuBackgroudColor?.color}
                    color={data.desktopMenuItemsTextColor?.color}
                    togglers={data.menuTogglersColor?.color}
                    locales={locales}
                    currentLocale={currentLocale}
                    items={first}
                  />
                </div>
                <div className="flex flex-row items-center py-4 cursor-pointer">
                  <CustomLink href="/">
                    <Image className={styles.imgSize} data={data.logo} />
                  </CustomLink>
                </div>
                <div className="hidden lg:flex xl:min-w-[20rem] justify-end">
                  <DesktopNavigationMenu
                    bg={data.desktopMenuBackgroudColor?.color}
                    color={data.desktopMenuItemsTextColor?.color}
                    togglers={data.menuTogglersColor?.color}
                    locales={locales}
                    currentLocale={currentLocale}
                    items={last}
                  />
                </div>
              </div>
              <div className="hidden lg:flex min-w-[6rem] justify-end">
                {data.addSocialLinks && (
                  <SocialLink
                    data={social.socialLinks}
                    color={data.menuTogglersColor?.color}
                  />
                )}
              </div>
              <div className="flex lg:hidden items-center">
                <BurgerMenuButton
                  close={data.closeMenuIcon?.img}
                  burger={data.burgerMenuIcon?.img}
                  color={data.menuTogglersColor?.color}
                  toggleMenu={activeMenu}
                  onClick={() => toggleMenu()}
                />
              </div>
            </nav>
          )}
        </>
      ) : (
        <>
          {data.navigationLinksAlignment == "right" ? (
            <>
              <nav className="navigationBar z-[1] flex-row justify-between px-6  lg:container mx-auto fixed  left-0 right-0 lg:absolute flex top-0 lg:bottom-0 h-[90px]">
                <div className="flex flex-row items-center py-4">
                  <CustomLink href="/">
                    <Image className={styles.imgSize} data={data.logo} />
                  </CustomLink>
                </div>
                <div className="flex flex-row gap-20">
                  <div className="hidden lg:flex">
                    <DesktopNavigationMenu
                      bg={data.desktopMenuBackgroudColor?.color}
                      color={data.desktopMenuItemsTextColor?.color}
                      togglers={data.menuTogglersColor?.color}
                      locales={locales}
                      currentLocale={currentLocale}
                      items={data.items}
                    />
                  </div>
                  <div className="flex lg:hidden items-center">
                    <BurgerMenuButton
                      close={data.closeMenuIcon?.img}
                      burger={data.burgerMenuIcon?.img}
                      color={data.menuTogglersColor?.color}
                      toggleMenu={activeMenu}
                      onClick={() => toggleMenu()}
                    />
                  </div>
                  {languageList.length > 1 && (
                    <div className="hidden lg:flex min-w-[6rem]">
                      <List tag="ordered" style="listBar">
                        <LangSelector
                          color={data.menuTogglersColor?.color}
                          locales={locales}
                          currentLocale={currentLocale}
                        />
                      </List>
                    </div>
                  )}
                </div>
              </nav>
            </>
          ) : (
            <>
              <nav className="navigationBar  z-[1]  flex-row justify-between px-6 lg:container mx-auto fixed  left-0 right-0 lg:static flex h-[90px]">
                <div className="flex flex-row items-center py-4">
                  <CustomLink href="/">
                    <Image className={styles.imgSize} data={data.logo} />
                  </CustomLink>
                </div>
                <div className="hidden lg:flex">
                  <DesktopNavigationMenu
                    bg={data.desktopMenuBackgroudColor?.color}
                    color={data.desktopMenuItemsTextColor?.color}
                    togglers={data.menuTogglersColor?.color}
                    locales={locales}
                    currentLocale={currentLocale}
                    items={data.items}
                  />
                </div>
                <div className="flex lg:hidden items-center">
                  <BurgerMenuButton
                    close={data.closeMenuIcon?.img}
                    burger={data.burgerMenuIcon?.img}
                    color={data.menuTogglersColor?.color}
                    toggleMenu={activeMenu}
                    onClick={() => toggleMenu()}
                  />
                </div>
                {languageList.length > 1 && (
                  <div className="hidden lg:flex min-w-[6rem]">
                    <List tag="ordered" style="listBar">
                      <LangSelector
                        color={data.menuTogglersColor?.color}
                        locales={locales}
                        currentLocale={currentLocale}
                      />
                    </List>
                  </div>
                )}
              </nav>
            </>
          )}
        </>
      )}

      <div className="lg:hidden z-40">
        <MobileNavigationMenu
          locales={locales}
          languageList={languageList}
          currentLocale={currentLocale}
          active={activeMenu}
          items={data.items}
          social={social}
          overwrite={data.overwriteSocialIconsColor}
          meta={data.metaItems}
          bg={data.mobileMenuBackgroundColor}
          metaBg={data.mobileMenuBackgroundColor}
          color={data.mobileMenuTextColor?.color}
          bgImage={data.mobileMenuBackgroundImage}
          togglers={data.menuTogglersColor?.color}
          online={data.onlineShopLinks}
          onClick={() => toggleMenu()}
        />
      </div>
    </DesignToken>
  );
}
